// Zoom functionality
document.querySelectorAll(".zoom-container").forEach((container) => {
  container.addEventListener("mousemove", function (e) {
    const img = this.querySelector(".zoom");
    const rect = this.getBoundingClientRect();
    const x = e.clientX - rect.left; //x position within the element.
    const y = e.clientY - rect.top; //y position within the element.
    const xPercent = Math.round((x / this.clientWidth) * 100);
    const yPercent = Math.round((y / this.clientHeight) * 100);
    img.style.transformOrigin = `${xPercent}% ${yPercent}%`;
  });
});

(function() {
  'use strict';

  let variantChangeUnsubscriber = null;

  function setupVariantChangeSubscription() {
    // Subscribe to variant change events (only once) - optional, direct listeners are primary
    if (!variantChangeUnsubscriber && typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      try {
        variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, handleVariantChange);
      } catch (e) {
        // Pub/sub not available, continue with direct listeners
      }
    }
    
    // Listen directly to all input/select changes that might be variant selectors
    function attachVariantListeners() {
      // Find all variant-selects elements
      const variantSelects = document.querySelectorAll('variant-selects');
      
      variantSelects.forEach((variantSelect) => {
        // Skip if already has listener
        if (variantSelect._mediaGalleryListenerAttached) {
          return;
        }
        
        variantSelect._mediaGalleryListenerAttached = true;
        const sectionId = variantSelect.dataset.section;
        
        // Listen to ALL change events inside variant-selects (capture phase)
        variantSelect.addEventListener('change', function(e) {
          // Wait for variant to update
          setTimeout(() => {
            const currentVariant = this.currentVariant;
            if (currentVariant && currentVariant.featured_media) {
              handleVariantChange({
                data: {
                  sectionId: sectionId,
                  variant: currentVariant
                }
              });
            }
          }, 200);
        }, true); // Capture phase
        
        // Also listen to individual inputs/selects inside
        const inputs = variantSelect.querySelectorAll('select, input[type="radio"], input[type="checkbox"]');
        inputs.forEach(input => {
          input.addEventListener('change', function() {
            setTimeout(() => {
              const currentVariant = variantSelect.currentVariant;
              if (currentVariant && currentVariant.featured_media) {
                handleVariantChange({
                  data: {
                    sectionId: sectionId,
                    variant: currentVariant
                  }
                });
              }
            }, 200);
          }, true);
        });
      });
    }
    
    // Also listen at document level for any change events
    document.addEventListener('change', function(e) {
      const variantSelect = e.target.closest('variant-selects');
      if (variantSelect) {
        setTimeout(() => {
          const currentVariant = variantSelect.currentVariant;
          if (currentVariant && currentVariant.featured_media) {
            handleVariantChange({
              data: {
                sectionId: variantSelect.dataset.section,
                variant: currentVariant
              }
            });
          }
        }, 200);
      }
    }, true); // Capture phase
    
    attachVariantListeners();
    
    if (typeof MutationObserver !== 'undefined') {
      const observer = new MutationObserver(() => {
        attachVariantListeners();
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
    
    // Retry after delays to catch elements that load later
    setTimeout(attachVariantListeners, 500);
    setTimeout(attachVariantListeners, 1000);
    setTimeout(attachVariantListeners, 2000);
  }

  function handleVariantChange(event) {
    if (!event?.data?.variant || !event?.data?.sectionId) {
      return;
    }

    const sectionId = event.data.sectionId;
    const variant = event.data.variant;

    // Check if variant has featured media
    if (!variant?.featured_media?.id) {
      return;
    }

    const featuredMediaId = String(variant.featured_media.id);
    
    // Try to find the slider container - try exact match first, then any slider
    let mainSliderContainer = document.querySelector(`.product-detail__thumbnail.main-slider[data-section="${sectionId}"]`);
    
    // If not found, try to find any slider container (fallback)
    if (!mainSliderContainer) {
      mainSliderContainer = document.querySelector('.product-detail__thumbnail.main-slider');
    }
    
    if (!mainSliderContainer) {
      return;
    }

    // Find the thumbnail with matching media ID and click it
    // This will trigger Splide's built-in navigation
    const thumbnailContainer = document.querySelector(`.product-detail__thumbnail-navigation.thumbnail-slider[data-section="${sectionId}"]`) ||
                               document.querySelector('.product-detail__thumbnail-navigation.thumbnail-slider');
    
    if (thumbnailContainer) {
      const thumbnailSlide = thumbnailContainer.querySelector(`.splide__slide[data-media-id="${featuredMediaId}"]`);
      if (thumbnailSlide) {
        // Click the thumbnail to trigger Splide navigation
        thumbnailSlide.click();
        return;
      }
    }
    
    // Fallback: try to find and click the main slide
    const mainSlide = mainSliderContainer.querySelector(`.splide__slide[data-media-id="${featuredMediaId}"]`);
    if (mainSlide) {
      mainSlide.click();
    }
  }

  // Initialize immediately and also on DOM ready
  function init() {
    setupVariantChangeSubscription();
  }
  
  // Run immediately if DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Also run after a short delay to catch late-loading elements
  setTimeout(init, 100);
  setTimeout(init, 500);
})();
